import React, { useEffect, useState, useRef } from "react";
import {
  FaApple,
  FaTimes,
  FaUser,
  FaWindows,
  FaHeart,
  FaChevronLeft,
  FaChevronRight,
  FaXbox,
} from "react-icons/fa";
import {
  FiFilter,
  FiGrid,
  FiPlay,
  FiSearch,
  FiStar,
  FiTrendingUp,
  FiAward,
  FiUsers,
  FiZap,
  FiCheck,
} from "react-icons/fi";
import { BiGitCompare } from "react-icons/bi";
import { FiShoppingCart } from "react-icons/fi";
import { TbDeviceVisionProFilled } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@mui/material";
import {
  getAllActiveGames,
  getAllActiveGamesWithPagination,
} from "../Redux/Slice/game.slice";
import { getAllCategories, getAllCategoriesWithGameCount } from "../Redux/Slice/category.slice";
import { DiAndroid } from "react-icons/di";
import { SiNintendoswitch, SiPlaystation, SiOculus, SiSteamdeck } from "react-icons/si";
import {
  addToCart as addToCartAction,
  fetchCart,
} from "../Redux/Slice/cart.slice";
import {
  addToWishlist,
  removeFromWishlist,
  fetchWishlist,
  checkWishlistStatus,
} from "../Redux/Slice/wishlist.slice";
import { useLocation, useNavigate } from "react-router-dom";
import gr from "../Asset/images/gr.svg";
// import gr2 from '../Asset/images/gr2.svg'
import gr3 from "../Asset/images/gr3.svg";
// import gr4 from '../Asset/images/gr4.svg'
import SEOHead from "../component/SEOHead";
import HyperButton from "../component/HyperButton";
import { motion } from "framer-motion";
import { BsGrid3X3Gap, BsListUl } from "react-icons/bs";
import BackgroundColor from "../component/BackgroundColor";
import ProductSkeleton from "../component/skeleton-loaders/ProductSkeleton";
import CategorySkeleton from "../component/skeleton-loaders/CategorySkeleton";

export default function Products() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("popular");
  const [grid, setGrid] = useState(3);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const sortDropdownRef = useRef(null);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const [selectedPlatforms, setSelectedPlatforms] = useState({});
  const categoriesName = useSelector((state) => state.category.categoriesWithCount);
  const cartItems = useSelector((state) => state.cart?.items || []);
  const { items: wishlistItems, wishlistStatus } = useSelector(
    (state) => state.wishlist
  );
  const userId = localStorage.getItem("yoyouserId");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategoryQ, setSelectedCategoryQ] = useState("all");
  const gamesPerPage = 12;
  const [isPageChanging, setIsPageChanging] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [maxPageButtons, setMaxPageButtons] = useState(5); // Default to 5 buttons
  const searchInputRef = useRef(null);
  const [compareGames, setCompareGames] = useState([]);
  const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);

  const {
    paginatedGames,
    totalGames,
    totalPages,
    loadingStates,
    error: gamesError,
  } = useSelector((state) => state.game);

  const { loadingStates: categoryLoadingStates, categories: categoryData } = useSelector((state) => state.category);

  useEffect(() => {
    document.title = "Games • YOYO";
    window.scrollTo(0, 0);
  }, [selectedCategory]);

  // Scroll to top when page changes
  // useEffect(() => {
  //   if (isPageChanging) {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //   }
  // }, [isPageChanging]);

  // Handle resize to adjust number of pagination buttons
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) { // md600 breakpoint
        setMaxPageButtons(3);
      } else if (window.innerWidth < 1024) { // lg breakpoint
        setMaxPageButtons(4);
      } else {
        setMaxPageButtons(6);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close sort dropdown on outside click or Escape
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && sortDropdownRef.current && !sortDropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  useEffect(() => {
    setIsInitialLoad(true);
    dispatch(getAllCategoriesWithGameCount());
    // Fetch cart items to check what's already added
    const userId = localStorage.getItem("yoyouserId");
    const token = localStorage.getItem("yoyoToken");
    if (userId && token) {
      dispatch(fetchCart());
      dispatch(fetchWishlist());
    }
  }, [dispatch]);

  useEffect(() => {
    // Debounce searchTerm
    const handler = setTimeout(() => {
      dispatch(
        getAllActiveGamesWithPagination({
          page: currentPage,
          limit: gamesPerPage,
          category: selectedCategoryQ._id,
          search: searchTerm?.trim(),
          isActive: true,
        })
      );
    }, 500); // 500ms debounce
    return () => {
      clearTimeout(handler);
    };
  }, [currentPage, selectedCategoryQ, searchTerm, dispatch]);

  // Reset page changing state when new data arrives
  useEffect(() => {
    if (paginatedGames && paginatedGames.length > 0) {
      setIsPageChanging(false);
    }
  }, [paginatedGames]);

  // Reset initial load state when categories are loaded
  useEffect(() => {
    if (categoriesName && categoriesName.length > 0) {
      setIsInitialLoad(false);
    }
  }, [categoriesName]);

  useEffect(() => {
    const st = location.state;
    if (!st || !Array.isArray(categoriesName)) {
      setSelectedCategoryQ("all"); // Default to "all" if no state or categories are available
      setSelectedCategory("all");
      return;
    }

    let foundCategory = null;

    if (st._id) {
      foundCategory = categoriesName.find((c) => c._id === st._id);
    } else if (st.id) {
      foundCategory = categoriesName.find(
        (c) => String(c.categoryName).toLowerCase() === String(st.id).toLowerCase()
      );
    } else if (st.name) {
      foundCategory = categoriesName.find(
        (c) => String(c.categoryName).toLowerCase() === String(st.name).toLowerCase()
      );
    }

    if (foundCategory) {
      setSelectedCategoryQ(foundCategory);
      setSelectedCategory(foundCategory.categoryName.toLowerCase());
    } else {
      setSelectedCategoryQ("all"); // Fallback to "all" if category not found
      setSelectedCategory("all");
    }

    setSearchTerm("");
    setCurrentPage(1);
  }, [location.state, categoriesName]);

  const options = [
    { value: "popular", label: "Most Popular" },
    { value: "price", label: "Price: Low to High" },
    { value: "price_desc", label: "Price: High to Low" },
    { value: "newest", label: "Newest First" },
  ];

  const handleSelect = (value) => {
    setSortBy(value);
    setIsOpen(false);
  };

  // Check if a game is already in cart for a specific platform
  const isGameInCart = (gameId, platform) => {
    return cartItems.some(
      (item) =>
        String(item.game?._id || item.game) === String(gameId) &&
        item.platform === platform
    );
  };

  // Icon mapping for categories
  const getIconForCategory = (categoryName) => {
    const iconMap = {
      action: FiZap,
      adventure: FiAward,
      puzzle: FiStar,
      racing: FiZap,
      sports: FiAward,
      strategy: FiStar,
      rpg: FiGrid,
      simulation: FiUsers,
      arcade: FiPlay,
      fighting: FiZap,
      platform: FiGrid,
      shooter: FiZap,
    };

    const key = categoryName?.toLowerCase();
    return iconMap[key] || FiGrid;
  };

  // Color mapping for categories
  const getColorForCategory = (categoryName) => {
    const colorMap = {
      action: "from-red-500 to-orange-500",
      adventure: "from-blue-500 to-indigo-500",
      puzzle: "from-purple-500 to-blue-500",
      racing: "from-yellow-500 to-orange-500",
      sports: "from-green-500 to-teal-500",
      strategy: "from-indigo-500 to-purple-500",
      rpg: "from-purple-500 to-pink-500",
      simulation: "from-cyan-500 to-blue-500",
      arcade: "from-pink-500 to-rose-500",
      fighting: "from-red-600 to-orange-600",
      platform: "from-green-400 to-blue-500",
      shooter: "from-gray-500 to-gray-700",
    };

    const key = categoryName.toLowerCase();
    return colorMap[key] || "from-purple-500 to-pink-500";
  };

  // Convert dynamic categories to the format expected by the component
  const getDynamicCategories = () => {
    const baseCategories = [
      {
        id: "all",
        name: "All Category",
        icon: FiGrid,
        count: categoriesName.reduce((acc, v) => acc + parseInt(v.gameCount), 0) || 0,
        color: "from-purple-500 to-pink-500",
      },
    ];

    const dynamicCategories =
      categoriesName?.map((category) => ({
        id: category?.categoryName.toLowerCase(),
        name: category?.categoryName,
        icon: getIconForCategory(category?.categoryName),
        count: category.gameCount,
        color: getColorForCategory(category?.categoryName),
        _id: category._id,
      })) || [];

    return [...baseCategories, ...dynamicCategories];
  };

  const getFormattedPaginatedGames = () => {
    return (
      paginatedGames?.map((game) => {
        const getAvailablePlatforms = () => {
          const platforms = game.platforms;
          if (!platforms) return {};
          const available = {};
          if (platforms.windows?.available)
            available.windows = platforms.windows;
          if (platforms.ios?.available) available.ios = platforms.ios;
          if (platforms.android?.available)
            available.android = platforms.android;
          if (platforms.nintendo?.available)
            available.nintendo = platforms.nintendo;
          if (platforms.quest?.available)
            available.quest = platforms.quest;
          if (platforms.playstation?.available)
            available.playstation = platforms.playstation;
          if (platforms.xbox?.available)
            available.xbox = platforms.xbox;
          if (platforms.visionpro?.available)
            available.visionpro = platforms.visionpro;
          if (platforms.steamdeck?.available)
            available.steamdeck = platforms.steamdeck;
          return available;
        };

        const getBestPrice = () => {
          const platforms = game.platforms;
          if (!platforms) return "Free";
          const prices = [];
          Object.keys(platforms).forEach((p) => {
            if (platforms[p].available && platforms[p].price > 0)
              prices.push(platforms[p].price);
          });
          return prices.length === 0 ? "Free" : Math.min(...prices);
        };

        const isNew =
          new Date(game.createdAt) >
          new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

        return {
          id: game._id,
          title: game.title,
          category: game.category?.categoryName?.toLowerCase() || "action",
          tags: game.tags || [],
          price: getBestPrice(),
          cover_image: game.cover_image?.url,
          video: game.video?.url,
          ratings: game.ratings || [],
          isNew,
          description: game.description,
          platforms: getAvailablePlatforms(),
          rawGame: game,
        };
      }) || []
    );
  };

  const categories = getDynamicCategories();
  categories.sort((a, b) => b.count - a.count);

  const games = getFormattedPaginatedGames();

  const toggleFavorite = (gameId) => {
    if (!userId) {
      navigate("/login");
      return;
    }

    const isInWishlist = wishlistStatus[gameId];
    if (isInWishlist) {
      dispatch(removeFromWishlist({ gameId }));
    } else {
      dispatch(addToWishlist({ gameId }));
    }
  };

  // Comparison toggle handler
  const handleToggleCompare = (game) => {
    if (compareGames.some((g) => g.id === game.id)) {
      setCompareGames((prev) => prev.filter((g) => g.id !== game.id));
    } else {
      if (compareGames.length >= 3) {
        alert("You can compare a maximum of 3 games.");
        return;
      }
      setCompareGames((prev) => [...prev, game]);
    }
  };

  // Video autoplay hover handlers
  const handleCardMouseEnter = (gameId) => {
    const videoEl = document.getElementById(`video-${gameId}`);
    if (videoEl) {
      videoEl.play().catch(() => { });
    }
  };

  const handleCardMouseLeave = (gameId) => {
    const videoEl = document.getElementById(`video-${gameId}`);
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
  };

  // Filter games based on category, search, platform, price, and rating
  const filteredGames = games.filter((game) => {
    const matchesCategory =
      selectedCategory === "all" ||
      game.category === selectedCategory ||
      (selectedCategory === "trending" && game.isNew);
    const matchesSearch =
      game.title?.trim().toLowerCase()?.includes(searchTerm?.trim().toLowerCase()) ||
      game.tags?.some((tag) =>
        tag?.trim().toLowerCase()?.includes(searchTerm?.trim().toLowerCase())
      );
    return matchesCategory && matchesSearch;
  });

  // Helper to get a game's price for sorting based on selected platform
  const getPriceForSorting = (game) => {
    const gamePlatforms = game.platforms || {};
    const selectedPlatformForGame =
      selectedPlatforms[game.id] || (gamePlatforms.windows ? "windows" : null);

    if (selectedPlatformForGame && gamePlatforms[selectedPlatformForGame]) {
      const price = gamePlatforms[selectedPlatformForGame].price;
      return typeof price === "number" ? price : 0;
    }

    const prices = Object.values(gamePlatforms)
      .map((p) => (typeof p?.price === "number" ? p.price : 0))
      .filter((n) => n > 0);
    return prices.length ? Math.min(...prices) : 0;
  };

  const sortedGames = [...filteredGames].sort((a, b) => {
    switch (sortBy) {
      case "popular":
        // Assuming "popular" implies maintaining the order provided by the backend
        // or no specific client-side sort if no popularity metric is available.
        // If a specific popularity metric (e.g., 'salesCount', 'views') exists on game objects,
        // it should be used here (e.g., `b.salesCount - a.salesCount`).
        return 0;
      case "price":
        return getPriceForSorting(a) - getPriceForSorting(b);
      case "price_desc":
        return getPriceForSorting(b) - getPriceForSorting(a);
      case "newest":
        // Sorts games with `isNew: true` before games with `isNew: false`.
        // If a `createdAt` timestamp was available, `new Date(b.createdAt) - new Date(a.createdAt)`
        // would provide a more precise "newest" sort.
        return (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0);
      default:
        return 0;
    }
  });

  useEffect(() => {
    if (isSearchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchOpen]);

  return (
    <>
      <SEOHead
        title="Browse Games"
        description="Explore our full catalog of games. Filter by platform (PC, Android, iOS, PlayStation, Xbox, Nintendo Switch, VR) or category. Find your next favorite game on Yoyo Game."
        keywords="browse games, game catalog, PC games download, Android games, iOS games, PlayStation games, Xbox games, Nintendo Switch games, VR games, buy games online"
        url="https://yoyokhel.com/games"
      />
      <BackgroundColor className="relative mx-auto w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%]">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden"
        >
          {/* <div className="absolute inset-0 bg-gradient-to-r from-purple-800/50 to-pink-800/50"></div> */}
          <div className="relative pt-20 pb-6 lg:py-16">
            <h1 className="text-[25px] lg:text-[60px] font-bold mb-3 text-center">
              <span className="gradient-text">Game </span>Universe
            </h1>
            <p className="text-sm lg:text-base text-primary-light/60 max-w-7xl mx-auto text-center mb-5 line-clamp-3 md:line-clamp-none">
              Welcome to Game center, You will be able to find all the games at one place. You can explore a very large and diverse collection or range of types or categories such as racing, sports, action, adventure, puzzles, and more. We have something for everyone, whether you prefer thrilling missions, a style of fighting, often in video games or sports, undisturbed games. Survey our whole collection, find new books and games, and have a relaxation and enjoyment at your fingertips.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-300">
              <HyperButton label="Explore" icon={FiZap} size="sm" />
              <HyperButton label="Buy" icon={FiShoppingCart} size="sm" />
              <HyperButton label="Enjoy" icon={FiPlay} size="sm" />
            </div>
          </div>
        </motion.div>

        <div className="relative pb-8">
          <div className="grid grid-cols-4 gap-4 lg:gap-8">
            {/* Categories Sidebar */}
            <motion.div
              initial={{ opacity: 0, x: -16 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="col-span-1 hidden md:block"
            >
              {(() => {
                const isLoading = categoryLoadingStates?.getAllCategories === true;
                const hasNoData = !categoriesName || categoriesName.length === 0;
                const shouldShowSkeleton = isLoading || isPageChanging || hasNoData || isInitialLoad;
                return shouldShowSkeleton;
              })() ? (
                <CategorySkeleton />
              ) : (
                <div className="bg-white/5 backdrop-blur-xl rounded-xl xl:rounded-3xl p-3 xl:p-6 border border-white/10 sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto no-scrollbar">
                  <h3 className="text-base lg:text-lg xl:text-2xl font-bold text-white mb-3 xl:mb-6 flex items-center gap-3">
                    <FiGrid className="hidden lg:block w-6 h-6 text-purple-400" />
                    Categories
                  </h3>
                  <div className="space-y-3">
                    {categories.map((category) => {
                      const IconComponent = category.icon;
                      return (
                        <button
                          key={category.id}
                          onClick={() => {
                            setSelectedCategory(category.id);
                            setSelectedCategoryQ(category);
                          }}
                          className={`w-full group relative overflow-hidden rounded-md xl:rounded-2xl transition-all duration-300 hover:scale-105 ${selectedCategory === category.id
                            ? "bg-gradient-to-r " +
                            category.color +
                            " text-white shadow-2xl"
                            : "bg-white/5 text-white/80 hover:bg-white/10 border border-white/10"
                            }`}
                        >
                          <div className="flex items-center justify-between p-2 xl:p-4">
                            <div className="flex items-center gap-3 text-sm">
                              {IconComponent && <IconComponent className="w-5 h-5 hidden lg:block" />}
                              <span className="font-medium">{category.name}</span>
                            </div>
                            <span
                              className={`hidden lg:block text-xs px-2 py-1 rounded-full ${selectedCategory === category.id
                                ? "bg-white/20"
                                : "bg-white/10"
                                }`}
                            >
                              {category.count}
                            </span>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </motion.div>

            {/* Games Grid */}

            <div className="md:col-span-3 col-span-4">
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                {/* Search and Filters */}
                <div className="bg-white/5 backdrop-blur-xl rounded-lg lg:rounded-2xl p-3 md:p-4 mb-4 border border-white/10 relative z-20">
                  <div className="flex md:justify-end flex-col md600:flex-row gap-3">
                    {/* Search */}
                    <div className="flex justify-start md:justify-end gap-1">
                      {isSearchOpen && (
                        <div className="relative flex-1">
                          <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white/60 w-5 h-5" />
                          <input
                            type="text"
                            placeholder="Search for your next adventure..."
                            value={searchTerm}
                            ref={searchInputRef}
                            onChange={(e) => { setCurrentPage(1); setSearchTerm(e.target.value); }}
                            className="w-full pl-12 pr-6 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all backdrop-blur text-sm"
                          />
                        </div>
                      )}
                      <button
                        onClick={() => {
                          setIsSearchOpen(!isSearchOpen);
                          setSearchTerm("");
                        }}
                        className="inline-flex md:hidden items-center justify-end text-xl rounded-full text-white/60 hover:text-white focus:outline-none transition-all duration-300 outline-none"
                      >
                        {isSearchOpen ? <FaTimes /> : <FiSearch />}
                      </button>
                    </div>

                    {/* Sort and View Controls */}
                    <div className="flex justify-start sm:justify-between flex-col sm:flex-row sm:items-center gap-2">
                      <button
                        onClick={() => {
                          setIsSearchOpen(!isSearchOpen);
                          setSearchTerm("");
                        }}
                        className="hidden md:inline-flex items-center justify-end text-xl rounded-full text-white/60 hover:text-white focus:outline-none transition-all duration-300 outline-none"
                      >
                        {isSearchOpen ? <FaTimes /> : <FiSearch />}
                      </button>

                      <div className="md:flex hidden gap-2 items-center">
                        <div className="flex items-center gap-2">
                          <button
                            className={`p-2 rounded-lg font-semibold transition text-xl flex items-center justify-center ${grid === 3
                              ? "bg-purple-600 text-white shadow"
                              : "bg-white/10 text-gray-300 hover:bg-purple-600 hover:text-white"
                              }`}
                            onClick={() => setGrid(3)}
                            aria-label="Card View"
                          >
                            <BsGrid3X3Gap />
                          </button>
                          <button
                            className={`p-2 rounded-lg font-semibold transition text-xl flex items-center justify-center ${grid === 1
                              ? "bg-purple-600 text-white shadow"
                              : "bg-white/10 text-gray-300 hover:bg-purple-600 hover:text-white"
                              }`}
                            onClick={() => setGrid(1)}
                            aria-label="List View"
                          >
                            <BsListUl />
                          </button>
                        </div>
                      </div>

                      <div className="flex gap-2">
                        <div className="flex items-center gap-2">
                          {/* <FiGamepad className="block sm:hidden text-white/60 w-5 h-5" /> */}
                          <div className="relative inline-block text-left md:hidden">
                            {/* Dropdown Button */}
                            <button
                              onClick={() => {
                                setIsCategoriesOpen(!isCategoriesOpen);
                                setIsOpen(false);
                              }}
                              className="bg-white/10 border border-white/20 rounded-md md:rounded-lg px-3 md:px-6 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-400 backdrop-blur flex justify-between items-center w-full sm375:w-44 md:w-64 lg:w-72 text-sm"
                            >
                              {/* Categories */}
                              {
                                categories.find((c) => c?.id === selectedCategory)
                                  ?.name
                              }
                              <svg
                                className={`w-4 h-4 ml-2 transition-transform ${isCategoriesOpen ? "rotate-180" : ""
                                  }`}
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </button>

                            {/* Dropdown Menu */}
                            {isCategoriesOpen && (
                              <div className="text-sm max-h-[300px] overflow-auto absolute mt-2 w-full sm375:w-44 md:w-64 lg:w-72 bg-black/80 backdrop-blur border border-white/10 rounded-md md:rounded-lg text-white z-50">
                                {categories.map((category) => {
                                  return (
                                    <button
                                      key={category.id}
                                      onClick={() => {
                                        setSelectedCategory(category.id);
                                        setSelectedCategoryQ(category)
                                        setIsCategoriesOpen(false);
                                      }}
                                      className={`w-full group relative overflow-hidden transition-all duration-300 ${selectedCategory === category.id
                                        ? "bg-gradient-to-r " +
                                        category.color +
                                        " text-white shadow-2xl"
                                        : "bg-white/5 text-white/80 hover:bg-white/10"
                                        }`}
                                    >
                                      <div className="flex items-center justify-start p-2">
                                        <span className="font-medium">
                                          {category.name}
                                        </span>
                                      </div>
                                      {selectedCategory === category.id && (
                                        <div className="absolute inset-0 bg-white/10 animate-pulse"></div>
                                      )}
                                    </button>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          {/* <FiFilter className="text-white/60 w-5 h-5" /> */}
                          <div className="relative inline-block text-left" ref={sortDropdownRef}>
                            {/* Dropdown Button */}
                            <button
                              onClick={() => {
                                setIsOpen(!isOpen);
                                setIsCategoriesOpen(false);
                              }}
                              className="bg-white/10 border border-white/20 rounded-md md:rounded-lg px-3 md:px-6 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-400 backdrop-blur flex justify-between items-center w-full sm375:w-36 md:w-48 lg:w-64 text-sm hover:bg-white/15 transition"
                            >
                              {options.find((o) => o.value === sortBy)?.label}
                              <svg
                                className={`w-4 h-4 ml-2 transition-transform ${isOpen ? "rotate-180" : ""
                                  }`}
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </button>

                            {/* Dropdown Menu */}
                            {isOpen && (
                              <div className="text-sm absolute mt-2 w-full sm375:w-36 md:w-48 lg:w-64 bg-black/80 backdrop-blur border border-white/10 rounded-md md:rounded-lg  shadow-2xl shadow-purple-900/20 text-white z-50 overflow-hidden">
                                {options.map((option) => (
                                  <div
                                    key={option.value}
                                    onClick={() => handleSelect(option.value)}
                                    className={`px-3 md:px-6 py-2 transition-colors ${sortBy === option.value
                                      ? "bg-purple-500/30 text-white"
                                      : "hover:bg-white/10 text-white/90"
                                      }`}
                                  >
                                    {option.label}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between mb-4 xl:mb-8">
                  <div>
                    {loadingStates.getAllActiveGamesWithPagination ? (
                      <>
                        <div className="h-8 bg-gray-600/50 rounded animate-pulse w-48 mb-2"></div>
                        <div className="h-4 bg-gray-600/50 rounded animate-pulse w-64"></div>
                      </>
                    ) : (
                      <>
                        <h2 className="text-xl xl:text-3xl font-bold text-white mb-1 xl:mb-2 tracking-wider">
                          {selectedCategory === "all"
                            ? "All Games"
                            : categories.find((c) => c.id === selectedCategory)
                              ?.name || "Games"}
                        </h2>
                        <p className="text-white/60 text-sm xl:text-base">
                          {selectedCategory === "all"
                            ? `Showing ${sortedGames?.length} of ${categories[0]?.count} games`
                            : `Showing ${sortedGames?.length} of ${selectedCategoryQ.count || selectedCategoryQ?.gameCount} games`
                          }
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </motion.div>

              <motion.section
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                {loadingStates.getAllActiveGamesWithPagination || isPageChanging || !sortedGames ? (
                  <ProductSkeleton grid={grid} />
                ) : (
                  <>
                    <div
                      className={`grid ${grid === 1
                        ? "grid-cols-1"
                        : "grid-cols-1 md600:grid-cols-2 3xl:grid-cols-3"
                        } gap-4 xl:gap-8 relative z-10`}
                    >
                      {sortedGames?.map((game, index) => {
                        const selectedPlatform =
                          selectedPlatforms[game.id] ||
                          Object.keys(game.platforms)[0] ||
                          "windows";
                        return (
                          <div
                            key={game.id}
                            className={`group relative bg-white/5 backdrop-blur-xl rounded-xl lg:rounded-3xl overflow-hidden border border-white/10 hover:border-purple-400/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/20  ${grid === 1 ? "md:flex" : ""
                              }`}
                            style={{ animationDelay: `${index * 0.1}s` }}
                            onMouseEnter={() => handleCardMouseEnter(game.id)}
                            onMouseLeave={() => handleCardMouseLeave(game.id)}
                            onClick={() => {
                              navigate(`/gamedetails/${game.id}`);
                            }}
                          >
                            {/* Image Container */}
                            <div
                              className={`relative overflow-hidden ${grid === 1
                                ? "w-full md:w-60 lg:w-64 md:h-full"
                                : "h-48"
                                }`}
                            >
                              <img
                                src={game?.cover_image}
                                alt={game?.title}
                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                              />
                              {game.video && (
                                <video
                                  id={`video-${game.id}`}
                                  src={game.video}
                                  muted
                                  loop
                                  playsInline
                                  className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                                />
                              )}
                              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                              {/* Badges */}
                              <div className="absolute top-4 left-4 flex gap-2">
                                {game.isNew && (
                                  <span className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
                                    NEW
                                  </span>
                                )}
                              </div>

                              {/* Action Buttons */}
                              <div className="absolute top-4 right-4 flex gap-2 opacity-100 transition-opacity duration-300 z-10">
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleToggleCompare(game);
                                  }}
                                  className={`p-2 rounded-full backdrop-blur-md transition-all duration-300 ${compareGames.some((cg) => cg.id === game.id)
                                    ? "bg-purple-600 text-white scale-110"
                                    : "bg-black/30 text-white hover:bg-purple-600 hover:scale-110"
                                    }`}
                                  title="Compare Game"
                                >
                                  <BiGitCompare className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleFavorite(game.id);
                                  }}
                                  className={`p-2 rounded-full backdrop-blur-md transition-all duration-300 ${wishlistStatus[game.id]
                                    ? "bg-red-500 text-white scale-110"
                                    : "bg-black/30 text-white hover:bg-red-500 hover:scale-110"
                                    }`}
                                >
                                  <FaHeart
                                    className={`w-4 h-4 ${wishlistStatus[game.id] ? "fill-current" : ""
                                      }`}
                                  />
                                </button>
                              </div>

                              {/* Play Button Overlay */}
                              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 z-5">
                                <button className="bg-white/90 text-gray-900 p-4 rounded-full hover:bg-white hover:scale-110 transition-all duration-300 shadow-2xl">
                                  <FiPlay className="w-6 h-6 ml-1" />
                                </button>
                              </div>
                            </div>

                            {/* Content */}
                            <div
                              className={`p-3 xl:p-6 ${grid === 1 ? "md:flex-1" : ""
                                }`}
                            >
                              <h3 className="text-base lg:text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">
                                {game.title.replace(/"/g, "")}
                              </h3>

                              <p className="text-gray-400 text-xs lg:text-sm mb-4 line-clamp-3">
                                {game.description.replace(/"/g, "")}
                              </p>
                              {/* Platforms */}
                              <div className="mt-4">
                                <h4 className="text-lg font-semibold text-white tracking-wider">
                                  Platforms :
                                </h4>
                                <div className="text-white/40 text-base flex gap-4 mt-2">
                                  {Object.keys(game.platforms).map((platform) => (
                                    <div
                                      key={platform}
                                      className={`flex items-center`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setSelectedPlatforms((prev) => ({
                                          ...prev,
                                          [game.id]: platform,
                                        }));
                                      }}
                                    >
                                      {platform === "windows" && (
                                        <FaWindows
                                          title="Show Windows Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-blue-500"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "ios" && (
                                        <FaApple
                                          title="Show Ios Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-white"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "android" && (
                                        <DiAndroid
                                          title="Show Android Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-green-500"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "nintendo" && (
                                        <SiNintendoswitch
                                          title="Show Nintendo Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-red-500"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "quest" && (
                                        <SiOculus
                                          title="Show Quest Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-sky-400"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "playstation" && (
                                        <SiPlaystation
                                          title="Show PlayStation Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-blue-500"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "xbox" && (
                                        <FaXbox
                                          title="Show Xbox Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-green-500"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "visionpro" && (
                                        <TbDeviceVisionProFilled
                                          title="Show Vision Pro Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-purple-400"
                                            : ""
                                            }`}
                                        />
                                      )}
                                      {platform === "steamdeck" && (
                                        <SiSteamdeck
                                          title="Show Steam Deck Price"
                                          className={`${selectedPlatform === platform
                                            ? "text-blue-400"
                                            : ""
                                            }`}
                                        />
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>

                              {/* Price and CTA */}
                              <div className="flex items-center md:items-start lg:items-center justify-between flex-row md:flex-col lg:flex-row">
                                <div className="mt-2 text-white flex flex-col gap-1 text-sm lg:text-base">
                                  <p className="">
                                    Price - ${" "}
                                    {game.platforms[selectedPlatform]?.price || 0}
                                  </p>
                                  <p className="">
                                    Size - {game.platforms[selectedPlatform]?.size || "N/A"}
                                  </p>
                                </div>

                                {isGameInCart(game.id, selectedPlatform) ? (
                                  <button
                                    disabled
                                    className="bg-gray-500 text-white px-1 py-2 lg:px-3 lg:py-2 text-sm rounded-md font-medium flex items-center gap-2 cursor-not-allowed mt-0 md:mt-2 lg:mt-0"
                                  >
                                    <FiShoppingCart className="w-4 h-4" />
                                    Already Added
                                  </button>
                                ) : !userId ? (
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      navigate("/login");
                                    }}
                                    className="bg-gradient-primary text-white p-2 lg:px-3 lg:py-2 text-sm rounded-md font-medium transition-all hover:scale-105 flex items-center gap-2 mt-0 md:mt-2 lg:mt-0"
                                  >
                                    <FaUser className="w-4 h-4" />
                                    Login to Add
                                  </button>
                                ) : (
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      dispatch(
                                        addToCartAction({
                                          gameId: game.id,
                                          platform: selectedPlatform,
                                          qty: 1,
                                        })
                                      );
                                    }}
                                    className="bg-gradient-primary text-white p-2 lg:px-3 lg:py-2 text-sm rounded-md font-medium transition-all hover:scale-105 flex items-center gap-2 mt-0 md:mt-2 lg:mt-0"
                                  >
                                    <FiShoppingCart className="w-4 h-4" />
                                    Add To Cart
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {sortedGames.length === 0 && !loadingStates.getAllActiveGamesWithPagination && !isPageChanging && (
                      <div className="text-center py-20">
                        <FiGrid className="w-16 h-16 text-white/30 mx-auto mb-4" />
                        <div className="text-white/60 text-2xl mb-4">
                          No games found
                        </div>
                        <div className="text-white/40">
                          Try adjusting your search or category filters
                        </div>
                      </div>
                    )}
                  </>
                )}
              </motion.section>
            </div>
            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex justify-center md600:justify-end items-center mt-8 space-x-2 col-span-4">
                <button
                  onClick={() => {
                    setIsPageChanging(true);
                    setCurrentPage((prev) => Math.max(1, prev - 1));
                  }}
                  disabled={currentPage === 1}
                  className="p-1 md:p-2 rounded-md text-white hover:bg-gray-700/40 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
                >
                  <FaChevronLeft />
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => {
                    const startPage = Math.max(
                      1,
                      currentPage - Math.floor(maxPageButtons / 2)
                    );
                    const endPage = Math.min(
                      totalPages,
                      startPage + maxPageButtons - 1
                    );

                    if (
                      page === 1 ||
                      page === totalPages ||
                      (page >= startPage && page <= endPage)
                    ) {
                      return (
                        <button
                          key={page}
                          onClick={() => {
                            setIsPageChanging(true);
                            setCurrentPage(page);
                          }}
                          className={`px-2 py-1 md:px-4 md:py-2 rounded-md text-sm sm:text-base font-medium transition-all duration-300 ring-[1px] ring-primary-light/10
                                            ${currentPage === page
                              ? "bg-gradient-primary text-white"
                              : " text-white hover:bg-gray-700/40"
                            }`}
                        >
                          {page}
                        </button>
                      );
                    }
                    if (
                      (page === startPage - 1 && startPage > 2) ||
                      (page === endPage + 1 && endPage < totalPages - 1)
                    ) {
                      return (
                        <span key={page} className="text-white">
                          ...
                        </span>
                      );
                    }
                    return null;
                  }
                )}

                <button
                  onClick={() => {
                    setIsPageChanging(true);
                    setCurrentPage((prev) => Math.min(totalPages, prev + 1));
                  }}
                  disabled={currentPage === totalPages}
                  className="p-1 md:p-2 rounded-md  text-white hover:bg-gray-700/40 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
                >
                  <FaChevronRight />
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Sticky Compare Drawer */}
        {compareGames.length > 0 && (
          <div className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[92%] max-w-5xl bg-[#0b0b0f]/95 backdrop-blur-xl border border-purple-500/40 p-4 z-40 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-2xl shadow-[0_0_30px_rgba(147,51,234,0.3)] transition-all duration-300">
            <div className="flex items-center gap-4 flex-wrap">
              <span className="text-white text-sm lg:text-base font-bold flex items-center gap-2">
                <BiGitCompare className="text-purple-400 animate-pulse text-lg" />
                Compare ({compareGames.length}/3)
              </span>
              <div className="flex gap-2 flex-wrap">
                {compareGames.map((cg) => (
                  <div
                    key={cg.id}
                    className="bg-white/5 border border-white/10 px-3 py-1.5 rounded-xl flex items-center gap-2 hover:bg-white/10 transition-colors"
                  >
                    <img src={cg.cover_image} alt="" className="w-8 h-8 rounded-lg object-cover border border-white/10" />
                    <span className="text-white text-xs font-semibold">{cg.title}</span>
                    <button
                      onClick={() => handleToggleCompare(cg)}
                      className="text-red-400 hover:text-red-300 p-0.5 rounded-full hover:bg-white/10 transition-colors"
                    >
                      <FaTimes size={10} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-4 w-full sm:w-auto justify-end">
              <button
                onClick={() => setCompareGames([])}
                className="text-white/60 hover:text-white text-xs lg:text-sm font-semibold transition-colors"
              >
                Clear All
              </button>
              <button
                onClick={() => setIsCompareModalOpen(true)}
                className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 py-2.5 rounded-xl text-xs lg:text-sm font-bold shadow-lg shadow-purple-500/20 hover:scale-105 hover:shadow-[0_0_15px_rgba(147,51,234,0.4)] transition-all"
              >
                Compare Now
              </button>
            </div>
          </div>
        )}

        {/* Comparison Modal */}
        <Modal
          open={isCompareModalOpen}
          onClose={() => setIsCompareModalOpen(false)}
          className="fixed inset-0 flex items-center justify-center z-[100] px-4 py-8 overflow-y-auto"
        >
          <div className="bg-[#0b0b0f]/95 backdrop-blur-2xl border border-purple-500/30 p-6 lg:p-10 text-white w-full max-w-5xl rounded-xl shadow-2xl outline-none max-h-[90vh] overflow-y-auto overflow-x-hidden scrollbar-hide relative">
            <div className="absolute -top-24 -right-24 w-72 h-72 bg-purple-600/10 rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" />

            <div className="flex justify-between items-center mb-8 pb-4 border-b border-white/10">
              <h2 className="text-2xl font-bold tracking-tight flex items-center gap-2">
                <BiGitCompare className="text-purple-400" />
                Game Comparison
              </h2>
              <button
                onClick={() => setIsCompareModalOpen(false)}
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-red-500/20 hover:text-red-500 transition-colors"
              >
                <FaTimes size={16} />
              </button>
            </div>

            <div className="w-full overflow-x-auto no-scrollbar pb-2">
              <div className="min-w-[850px] md:min-w-0 grid grid-cols-1 md:grid-cols-4 gap-4 border border-white/10 rounded-2xl overflow-hidden divide-y md:divide-y-0 md:divide-x divide-white/10 bg-white/[0.02]">
                {/* Criteria Column */}
                <div className="p-4 space-y-8 font-bold text-purple-300/80 text-xs uppercase tracking-wider hidden md:block">
                  <div className="h-64 flex items-end pb-2 border-b border-white/5">Game</div>
                  <div className="h-12 flex items-center">Price</div>
                  <div className="h-12 flex items-center">Platform Support</div>
                  <div className="h-12 flex items-center">Rating</div>
                  <div className="h-12 flex items-center">Download Size</div>
                  <div className="h-32 flex items-center">Windows Requirements</div>
                  <div className="h-32 flex items-center">Mobile & Console Specs</div>
                </div>

                {/* Game Columns */}
                {compareGames.map((cg) => {
                  const rating = cg.ratings.length
                    ? (cg.ratings.reduce((acc, r) => acc + r.rating, 0) / cg.ratings.length).toFixed(1)
                    : "No ratings";

                  const winPlat = cg.rawGame.platforms?.windows;
                  const iosPlat = cg.rawGame.platforms?.ios;
                  const androidPlat = cg.rawGame.platforms?.android;
                  const firstAvailPlatform = Object.keys(cg.platforms)[0];

                  return (
                    <div key={cg.id} className="p-4 space-y-8 text-sm text-white flex flex-col md:block">
                      {/* Game Details Header */}
                      <div className="md:h-64 flex flex-col items-center md:items-start justify-between gap-4 pb-4 border-b border-white/5">
                        <div className="flex flex-col items-center md:items-start gap-3 w-full">
                          <img src={cg.cover_image} alt="" className="w-28 h-32 rounded-xl object-cover shadow-lg border border-white/10 group-hover:scale-105 transition-transform" />
                          <div className="text-center md:text-left min-w-0 w-full">
                            <h3 className="font-bold text-base line-clamp-1 text-white hover:text-purple-300 transition-colors" title={cg.title}>{cg.title}</h3>
                            <span className="text-[10px] uppercase font-semibold text-purple-400 bg-purple-500/10 px-2 py-0.5 rounded-full mt-1 inline-block">
                              {cg.category}
                            </span>
                          </div>
                        </div>

                        {/* Actions Row */}
                        <div className="w-full flex flex-col gap-2 mt-auto">
                          <button
                            onClick={() => {
                              setIsCompareModalOpen(false);
                              navigate(`/gamedetails/${cg.id}`);
                            }}
                            className="w-full bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium py-1.5 px-3 rounded-lg text-xs transition"
                          >
                            View Details
                          </button>

                          {firstAvailPlatform ? (
                            isGameInCart(cg.id, firstAvailPlatform) ? (
                              <button
                                disabled
                                className="w-full bg-gray-500/20 text-gray-400 font-medium py-1.5 px-3 rounded-lg text-xs flex items-center justify-center gap-1.5 cursor-not-allowed border border-white/5"
                              >
                                <FiShoppingCart className="w-3.5 h-3.5" />
                                Already in Cart
                              </button>
                            ) : !userId ? (
                              <button
                                onClick={() => {
                                  setIsCompareModalOpen(false);
                                  navigate("/login");
                                }}
                                className="w-full bg-gradient-primary text-white font-medium py-1.5 px-3 rounded-lg text-xs flex items-center justify-center gap-1.5 transition hover:opacity-90"
                              >
                                <FaUser className="w-3.5 h-3.5" />
                                Login to Add
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  dispatch(
                                    addToCartAction({
                                      gameId: cg.id,
                                      platform: firstAvailPlatform,
                                      qty: 1,
                                    })
                                  );
                                }}
                                className="w-full bg-gradient-primary text-white font-medium py-1.5 px-3 rounded-lg text-xs flex items-center justify-center gap-1.5 transition hover:opacity-90"
                              >
                                <FiShoppingCart className="w-3.5 h-3.5" />
                                Add to Cart
                              </button>
                            )
                          ) : (
                            <button
                              disabled
                              className="w-full bg-white/5 text-gray-500 font-medium py-1.5 px-3 rounded-lg text-xs cursor-not-allowed border border-white/5"
                            >
                              Unavailable
                            </button>
                          )}
                        </div>
                      </div>

                      {/* Price */}
                      <div className="h-12 flex items-center justify-between md:justify-start">
                        <span className="md:hidden font-bold text-purple-300/80 mr-2 text-xs uppercase tracking-wider">Price:</span>
                        <span className="font-bold text-green-400 text-base">
                          {typeof cg.price === "number" ? `$${cg.price}` : cg.price}
                        </span>
                      </div>

                      {/* Platform Support */}
                      <div className="h-12 flex items-center justify-between md:justify-start gap-3">
                        <span className="md:hidden font-bold text-purple-300/80 mr-2 text-xs uppercase tracking-wider">Platforms:</span>
                        <div className="flex gap-2 text-white/60">
                          {winPlat?.available && <FaWindows className="text-blue-500 text-base" title="Windows" />}
                          {iosPlat?.available && <FaApple className="text-white text-base" title="iOS" />}
                          {androidPlat?.available && <DiAndroid className="text-green-500 text-base" title="Android" />}
                          {cg.rawGame.platforms?.nintendo?.available && <SiNintendoswitch className="text-red-500 text-base" title="Nintendo Switch" />}
                          {cg.rawGame.platforms?.quest?.available && <SiOculus className="text-sky-400 text-base" title="Meta Quest" />}
                          {cg.rawGame.platforms?.playstation?.available && <SiPlaystation className="text-blue-500 text-base" title="PlayStation" />}
                          {cg.rawGame.platforms?.xbox?.available && <FaXbox className="text-green-500 text-base" title="Xbox" />}
                          {cg.rawGame.platforms?.visionpro?.available && <TbDeviceVisionProFilled className="text-purple-400 text-base" title="Vision Pro" />}
                          {cg.rawGame.platforms?.steamdeck?.available && <SiSteamdeck className="text-blue-400 text-base" title="Steam Deck" />}
                        </div>
                      </div>

                      {/* Rating */}
                      <div className="h-12 flex items-center justify-between md:justify-start">
                        <span className="md:hidden font-bold text-purple-300/80 mr-2 text-xs uppercase tracking-wider">Rating:</span>
                        <span className="flex items-center gap-1 text-yellow-400 font-bold text-base">
                          <FiStar className="fill-current" />
                          {rating}
                        </span>
                      </div>

                      {/* Size */}
                      <div className="h-12 flex items-center justify-between md:justify-start">
                        <span className="md:hidden font-bold text-purple-300/80 mr-2 text-xs uppercase tracking-wider">Size:</span>
                        <span className="font-medium">
                          {winPlat?.size || androidPlat?.size || iosPlat?.size ||
                            cg.rawGame.platforms?.nintendo?.size || cg.rawGame.platforms?.quest?.size ||
                            cg.rawGame.platforms?.playstation?.size || cg.rawGame.platforms?.xbox?.size ||
                            cg.rawGame.platforms?.visionpro?.size || cg.rawGame.platforms?.steamdeck?.size || "N/A"}
                        </span>
                      </div>

                      {/* Windows Specs */}
                      <div className="h-32 flex flex-col justify-center text-xs text-gray-300 space-y-1.5">
                        <span className="md:hidden font-bold text-purple-300/80 mb-1 text-xs uppercase tracking-wider">Windows Specs:</span>
                        {winPlat?.available ? (
                          <div className="bg-white/[0.02] border border-white/5 rounded-xl p-2.5 space-y-1">
                            <div className="line-clamp-1"><b>OS:</b> {winPlat.system_requirements?.os || "N/A"}</div>
                            <div className="line-clamp-1"><b>CPU:</b> {winPlat.system_requirements?.processor || "N/A"}</div>
                            <div className="line-clamp-1"><b>RAM:</b> {winPlat.system_requirements?.memory || "N/A"}</div>
                            <div className="line-clamp-1"><b>GPU:</b> {winPlat.system_requirements?.graphics || "N/A"}</div>
                          </div>
                        ) : (
                          <span className="text-gray-500 italic">Not supported on Windows</span>
                        )}
                      </div>

                      {/* Mobile & Console Specs */}
                      <div className="h-32 flex flex-col justify-center text-xs text-gray-300 space-y-1.5 overflow-y-auto no-scrollbar">
                        <span className="md:hidden font-bold text-purple-300/80 mb-1 text-xs uppercase tracking-wider">Mobile & Console Specs:</span>
                        {androidPlat?.available || iosPlat?.available || cg.rawGame.platforms?.nintendo?.available || cg.rawGame.platforms?.quest?.available || cg.rawGame.platforms?.playstation?.available || cg.rawGame.platforms?.xbox?.available || cg.rawGame.platforms?.visionpro?.available || cg.rawGame.platforms?.steamdeck?.available ? (
                          <div className="bg-white/[0.02] border border-white/5 rounded-xl p-2.5 space-y-1 max-h-full overflow-y-auto no-scrollbar">
                            {androidPlat?.available && (
                              <div className="line-clamp-1"><b>Android:</b> {androidPlat.system_requirements?.android_version || "N/A"}</div>
                            )}
                            {iosPlat?.available && (
                              <div className="line-clamp-1"><b>iOS:</b> {iosPlat.system_requirements?.ios_version || "N/A"}</div>
                            )}
                            {cg.rawGame.platforms?.nintendo?.available && (
                              <div className="line-clamp-1"><b>Switch:</b> {cg.rawGame.platforms.nintendo.system_requirements?.device_compatibility || "N/A"}</div>
                            )}
                            {cg.rawGame.platforms?.quest?.available && (
                              <div className="line-clamp-1"><b>Quest:</b> {cg.rawGame.platforms.quest.system_requirements?.device_compatibility || "N/A"}</div>
                            )}
                            {cg.rawGame.platforms?.playstation?.available && (
                              <div className="line-clamp-1"><b>PS:</b> {cg.rawGame.platforms.playstation.system_requirements?.device_compatibility || "N/A"}</div>
                            )}
                            {cg.rawGame.platforms?.xbox?.available && (
                              <div className="line-clamp-1"><b>Xbox:</b> {cg.rawGame.platforms.xbox.system_requirements?.device_compatibility || "N/A"}</div>
                            )}
                            {cg.rawGame.platforms?.visionpro?.available && (
                              <div className="line-clamp-1"><b>Vision Pro:</b> {cg.rawGame.platforms.visionpro.system_requirements?.device_compatibility || "N/A"}</div>
                            )}
                            {cg.rawGame.platforms?.steamdeck?.available && (
                              <div className="line-clamp-1"><b>Steam Deck:</b> {cg.rawGame.platforms.steamdeck.system_requirements?.device_compatibility || "N/A"}</div>
                            )}
                          </div>
                        ) : (
                          <span className="text-gray-500 italic">No specs available</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal>
      </BackgroundColor>
    </>
  );
}
